import uppercase from './upperCase';
import formatYearFromTill from './formatYearFromTill'
import checkstock from './checkstock'
import formatString from './formatString'

export default {
    install(Vue) {
        Vue.filter('uppercase', uppercase);
        Vue.filter('formatYearFromTill', formatYearFromTill);
        Vue.filter('checkstock', checkstock);
        Vue.filter('formatString', formatString);
    },
}